import { ref, onMounted, onUnmounted } from 'vue';
import axios from 'axios';
import { normalizeVaults } from '@/services/vaults.mjs';

const records = ref(null);
const loading = ref(false);
const error = ref('');
const checkedAt = ref(null);
let pending;
let timer;
let subscribers = 0;

export function refreshVaultDirectory() {
  if (pending) return pending;
  loading.value = true;
  pending = axios.get('/market-api/vaults', { timeout: 15000 }).then(({ data }) => {
    records.value = normalizeVaults(data);
    checkedAt.value = Date.now();
    error.value = '';
  }).catch(() => {
    records.value = null;
    error.value = 'Emblem’s vault references are temporarily unavailable.';
  }).finally(() => { loading.value = false; pending = null; });
  return pending;
}

export default function useVaultDirectory() {
  onMounted(() => {
    if (++subscribers === 1) {
      if (!records.value || Date.now() - checkedAt.value >= 60000) refreshVaultDirectory();
      timer = setInterval(refreshVaultDirectory, 60000);
    }
  });
  onUnmounted(() => { if (--subscribers === 0) clearInterval(timer); });
  return { records, loading, error, checkedAt, refresh: refreshVaultDirectory };
}
